import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";

const resource = `${Config.basePath}/call`;

export default {
  getUserById(id) {
    return Client.get(`${resource}/user/caller-info`, {
      params: { acsUserId: id },
    });
  },
  createCallUser() {
    return Client.post(`${resource}/user/create`);
  },
  findSession(params) {
    return Client.get(`${resource}/session/find-by-acs-user-id`, {
      params,
    });
  },
  notify(payload) {
    return Client.post(`${resource}/session/notify`, payload);
  },
};
